import {BaseService} from './Core/BaseService';
import {ObjectUtils} from "../Utils";

class ProgramBenefitSpreadsheetService extends BaseService {
    get Url() { return super.Url + "/programBenefitSpreadsheets"; }

    DownloadFile(fileName, id, targetValue, programLength) {
        let anchor = document.createElement("a");
        let queryString = ObjectUtils.BuildQueryString({
            'targetValue': targetValue,
            "programLength": programLength
        });

        let file = this.Url + "/" + String(id) + "?" + queryString

        let headers = new Headers();
        headers.append('Authorization', BaseService.AUTH_TOKEN);

        fetch(file, { headers })
            .then(response => {
                if (!response.ok) {
                    alert('Unfortunately we have failed to download the file.')
                }
                return response;
            })
            .then(response => response.blob())
            .then(blobby => {
                let objectUrl = window.URL.createObjectURL(blobby);
                anchor.href = objectUrl;
                anchor.download = fileName;
                anchor.click();
                URL.revokeObjectURL(objectUrl);
            });
    }

    UploadFile() {

    }
}

export const service = new ProgramBenefitSpreadsheetService();

